import {api, paramEncoder} from "./repository";
const resource = "/invites";

export default {
    getAll(params) {
        return api.get(`${resource}${paramEncoder(params)}`);
    },
    store(payload) {
        return api.post(resource, payload);
    },
    getById(id, params) {
        return api.get(`${resource}/${id}${paramEncoder(params)}`);
    },
    getByPublicUuid(uuid, params){
        return api.get(`invitation/${uuid}${paramEncoder(params)}`);
    },
    viewed(uuid) {
        return api.post(`invitation/${uuid}/viewed`);
    },
    confirm(uuid, payload){
        return api.post(`invitation/${uuid}/confirm`, payload);
    },
    reject(uuid) {
        return api.post(`invitation/${uuid}/reject`);
    },
    update(payload) {
        let id = payload.id;
        return api.put(`${resource}/${id}`, payload);
    },
    destroy(id) {
        return api.delete(`${resource}/${id}`);
    },
    sendEmails(ids){
        return api.post(`${resource}/send-email`, {ids})
    },
    sendSMSMessages(ids) {
        return api.post(`${resource}/send-sms`, {ids})
    },
    sendAnswers(uuid, payload) {
        return api.post(`invitation/${uuid}/send-answers`, payload);
    },
    subscribe(payload) {
        return api.post(`mailchimp/subscribe`, payload);
    },
    createPaymentIntent(payload) {
        return api.post(`payments/create-payment-intent`, payload);
    },
    smsOptIn(uuid) {
        return api.post(`invitation/${uuid}/sms-opt-in`);
    },
    smsOptOut(uuid) {
        return api.post(`invitation/${uuid}/sms-opt-out`);
    }
}